module.exports = __webpack_public_path__ + "assets/14f5aed523f8c559e4c7ad06b741a29a.png";